/**
 * 業務・業務ルール（F3）のルート定義。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務詳細（データの流れの図）・ロジック図の見本（v2 ・ v3）・業務ルールのルートと、旧 URL（業務ロジック ・ データの流れ）の倒し先を定義する。
 * @graph-connects none
 */
import { createRoute } from '@tanstack/react-router';
import { BusinessLogicMockV2Page, BusinessLogicMockV3Page } from '../BusinessLogicMockPage.js';
import { parseDataflowSearch } from '../flow-search.js';
import { LegacyBusinessRedirect } from '../LegacyBusinessRedirect.js';
import { parsePjSearch } from '../pj-search.js';
import { BusinessDataflowRoutePage } from '../receivers/business-dataflow.js';
import {
  BUSINESS_DATAFLOW_ROUTE,
  BUSINESS_DETAIL_ROUTE,
  BUSINESS_DETAIL_V2_ROUTE,
  BUSINESS_DETAIL_V3_ROUTE,
  BUSINESS_LOGIC_ROUTE,
  RULE_ROUTE,
} from '../route-paths.js';
import { RulePage } from '../RulePage.js';
import { rootRoute } from './root.js';

/**
 * 業務詳細（データの流れの図）。検索条件は案件（`?pj=`）と左右比較の開閉（`?compare=0`）を読む。
 * @graph-connects none
 */
export const businessDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_DETAIL_ROUTE,
  component: BusinessDataflowRoutePage,
  validateSearch: parseDataflowSearch,
});

/** ロジック図の見本 v2（マッチ度を業務ルールで表す案、mock）。 @graph-connects none */
export const businessLogicMockV2Route = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_DETAIL_V2_ROUTE,
  component: BusinessLogicMockV2Page,
});

/** ロジック図の見本 v3（判断をすべて分岐で表す案、mock）。 @graph-connects none */
export const businessLogicMockV3Route = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_DETAIL_V3_ROUTE,
  component: BusinessLogicMockV3Page,
});

/** 旧 業務ロジック。業務詳細へ倒す。 @graph-connects none */
export const legacyBusinessLogicRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_LOGIC_ROUTE,
  component: LegacyBusinessRedirect,
});

/** 旧 データの流れ。業務詳細へ倒す。 @graph-connects none */
export const legacyBusinessDataflowRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_DATAFLOW_ROUTE,
  component: LegacyBusinessRedirect,
});

/** 業務ルール 1 件。検索条件は案件（`?pj=`）を読む。 @graph-connects none */
export const ruleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: RULE_ROUTE,
  component: RulePage,
  validateSearch: parsePjSearch,
});

/** 業務・業務ルールのルート（旧 URL の倒し先を含む）。ルート木（`app.tsx`）はこれを並べる。 @graph-connects none */
export const businessLogicRoutes = [
  businessDetailRoute,
  businessLogicMockV2Route,
  businessLogicMockV3Route,
  legacyBusinessLogicRoute,
  legacyBusinessDataflowRoute,
  ruleRoute,
] as const;
